import styled from '@emotion/styled';
import { FormattedMessage } from 'react-intl';

const StyledMessage = styled('p')(({ theme }) => ({
  marginTop: 16,
  marginBottom: 0,
  color: theme.palette.text.secondary,
  fontStyle: 'italic',
  fontSize: '0.9em',
  '&::first-letter': {
    textTransform: 'capitalize',
  },
}));

type EmptyLogEntryMessageProps = {
  logEntryName: string;
};

const EmptyLogEntryMessage = ({ logEntryName }: EmptyLogEntryMessageProps) => (
  <StyledMessage>
    <FormattedMessage
      id="portfolio.challenge.log_entries.empty_log_entry_message"
      values={{
        logEntryName,
      }}
    />
  </StyledMessage>
);

export default EmptyLogEntryMessage;
